<template>
    <div>
      <b-modal
          id="modal-user-document-history"
          @ok="$bvModal.hide('modal-user-document-history')"
          cancel-title="Aizvērt"
          size="xl"
      >
        <b-table
            :fields="modalFields"
            :items="historyItemProvider"
            :key="'modal-user-list'"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by="'period.startDate'"
            :sort-desc="false"
            no-provider-paging
            sort-icon-left
            no-sort-reset
            small
        ></b-table>
        <b-pagination
            :per-page="20"
            :total-rows="totalRows"
            v-model="currentPage"
            first-number
            last-number
            align="center"
            size="sm"
        ></b-pagination>
      </b-modal>
</div>
</template>
<script>
  import axios from 'axios';
  import * as authStoreTypes from "../../../vuex/modules/auth/auth.store-types";
  import { mapGetters } from 'vuex';
  export default {
      name: 'modal-user-document-user-history',
      data: () => ({
        perPage: 20,
        currentPage: 1,
        totalRows: 0,
          userId: null,
          filter: null,
        modalFields: [
          {
            key: 'document.category.name',
            label:'Kategorija'
          },
          {
            key: 'document.name',
            label:'Dokuments'
          },
          {
            key: 'document.documentForm.type',
            label: 'Tips',
            formatter: value => value === 'custom' ? 'Tests' : 'Iepazīšanās'
          },
          {
            key:'period.startDate',
            label: 'Perioda sākums',
            formatter: value => new Date(value).toLocaleDateString("lv")
          },
          {
            key:'period.endDate',
            label: 'Perioda beigas',
            formatter: value => value ? new Date(value).toLocaleDateString("lv") : '-'
          },
          // {
          //   key:'attempts',
          //   label: 'Mēģinājumi',
          //   formatter: value => value || 'Nav informācijas'
          // },
          {
            key: 'correctAnswers',
            label: 'Pareizās atbildes',
            formatter: (value, key, item) => item.document.documentForm.type == 'custom' ? `${value} / ${item.document.documentForm.totalQuestions}` : '-'

          },
          {
           key: 'isPassed',
            label: 'Izpildīts',
            formatter: value => value ? 'Jā' : 'Nē'
          },
          {
            key: 'updatedAt',
            label: 'Iziešanas datums',
            formatter: (value, key, item) => item.isPassed ? value : '-'
          }


        ]
      }),
      created() {
    },
    mounted() {
        this.$root.$on('user:modal:document-history:show', ({userId}) => {
          this.userId = userId
          this.$bvModal.show('modal-user-document-history')
        })
    },
      computed: {
        ...mapGetters('auth', {
          /** @type {CurrentUser|*} */
          currentUser: authStoreTypes.GET_CURRENT_USER,
        }),
      },
      methods: {
        async historyItemProvider() {
          const { data } = await axios.get(`/api/companies/${this.$route.params.companyId || this.currentUser.company._id}/users/${this.userId}/document-history`);
          this.totalRows = data.documentHistory.length;
          return data.documentHistory
        },

      }
  }
  </script>
  